import { Controls } from './controls';
import { Docs } from './docs';
import { Experiments } from './experiments';
import { parseFlags } from './utils';
import type { DataFile, Flag } from './types';
import css from './flags.module.scss';

interface Props {
    dataFile: DataFile;
}
export function Flags({ dataFile }: Props) {
    const experiments: Flag[] = Object.values(parseFlags(dataFile));

    return (
        <div className={css.wrapper}>
            <Controls total={experiments.length} />
            <Experiments flags={experiments} />
            <Docs />
        </div>
    );
}
